export default function OverlayLoader() {
  const bars = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]

  return (
    <>
      {/* <div id="overlay">
        <div id="text">
          <Loader size="lg" content="" />
          <p style={{ marginTop: 50 }}>ระบบกำลังประมวลผล...</p>
        </div>
      </div> */}
      <div class="loading-overlay">
        <div class="helix-loader">
          {bars.map((e) => (
            <div class="bar"></div>
          ))}
        </div>
        <p class="loading-text">ระบบกำลังประมวลผล...</p>
      </div>
    </>
  )
}
